export const ASSIGNMENT_REMOVAL = 'ASSIGNMENT_REMOVAL';
export const FILTER_CHANGE_REMOVAL = 'FILTER_CHANGE_REMOVAL';
export const THREAD_STATUS_REMOVAL = 'THREAD_STATUS_REMOVAL';
export const ASSOCIATED_TICKET_REMOVAL = 'ASSOCIATED_TICKET_REMOVAL';
export const UNKNOWN_REMOVAL = 'UNKNOWN_REMOVAL';
export const FILTER_MISALIGNMENT = 'FILTER_MISALIGNMENT';
export const HARD_DELETION_REMOVAL = 'HARD_DELETION_REMOVAL';
export const INBOX_CHANGE_REMOVAL = 'INBOX_CHANGE_REMOVAL';